import { PropertiesService } from './properties.service';
import { RegionService } from './region.service';
import * as i0 from "@angular/core";
import * as i1 from "./properties.service";
import * as i2 from "./region.service";
var ExternalLinksService = /** @class */ (function () {
    function ExternalLinksService(propertiesService, regionService) {
        this.propertiesService = propertiesService;
        this.regionService = regionService;
    }
    ExternalLinksService.prototype.getUserProfileUrl = function () {
        return this.propertiesService.get('userProfileUrl');
    };
    ExternalLinksService.prototype.getPrivacyPolicyUrl = function () {
        var countryCode = this.regionService.getCountryCode();
        return this.propertiesService.get("privacyPolicyUrl" + countryCode);
    };
    ExternalLinksService.prototype.getCustomerServiceUrl = function () {
        var countryCode = this.regionService.getCountryCode();
        return this.propertiesService.get("customerServiceUrl" + countryCode);
    };
    ExternalLinksService.prototype.getTermsUrl = function () {
        var countryCode = this.regionService.getCountryCode();
        return this.propertiesService.get("termsUrl" + countryCode);
    };
    ExternalLinksService.prototype.getWinnersListUrl = function () {
        var countryCode = this.regionService.getCountryCode();
        return this.propertiesService.get("winnersListUrl" + countryCode);
    };
    ExternalLinksService.prototype.getFaqUrl = function () {
        var countryCode = this.regionService.getCountryCode();
        return this.propertiesService.get("faqUrl" + countryCode);
    };
    ExternalLinksService.prototype.getGooglePlayAppUrl = function () {
        return this.propertiesService.get('googlePlayAppUrl');
    };
    ExternalLinksService.prototype.getSiteAddres = function () {
        var loc = window.location;
        return loc.protocol + '//' + loc.host;
    };
    ExternalLinksService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function ExternalLinksService_Factory() { return new ExternalLinksService(i0.ɵɵinject(i1.PropertiesService), i0.ɵɵinject(i2.RegionService)); }, token: ExternalLinksService, providedIn: "root" });
    return ExternalLinksService;
}());
export { ExternalLinksService };
